import invariant from 'invariant';
import { useCallback } from 'react';

import type { ApiFilestackImageOrVideoDataWithCaption } from '#/api/types/ApiFilestackImageData';

type Args = {
  values: ApiFilestackImageOrVideoDataWithCaption[] | null | undefined;
  onChange: (data: ApiFilestackImageOrVideoDataWithCaption[]) => void;
};

export function useMultiImagePickerRemoveImage({ values, onChange }: Args) {
  const removeImage = useCallback(
    (index: number) => {
      invariant(values, 'Missing image to remove');

      const newValues = [...values];
      newValues.splice(index, 1);
      onChange(newValues);
    },
    [values, onChange],
  );

  return { removeImage };
}
